export default __webpack_public_path__ + "static/media/a0ab1935f8af12d04a10f4859fbe608e.svg";